import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { StripMarquee } from "@/components/site/StripMarquee";
import { LogoSection } from "@/components/site/LogoSection";
import { Manifesto } from "@/components/site/Manifesto";
import { Gallery } from "@/components/site/Gallery";
import { KindnessReel } from "@/components/site/KindnessReel";
import { LiveSection } from "@/components/site/LiveSection";
import { Impact } from "@/components/site/Impact";
import { Donate } from "@/components/site/Donate";
import { Volunteer } from "@/components/site/Volunteer";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <StripMarquee />
      <LogoSection />
      <Manifesto />
      <Gallery />
      <KindnessReel />
      <LiveSection />
      <Impact />
      <Donate />
      <Volunteer />
      <Contact />
      <Footer />
      <ChatWidget />
    </main>
  );
}
